// Sonder-Zuordnungen für Dokumente, die zu KEINER Firma gehören.
// Als mandant_id-Sentinel in der Akte gespeichert (reiner String, kein
// echter Mandant) — tauchen nur in der Dokumente-Übersicht + Suche auf.

export const KAT_ALLGEMEIN = '__allgemein__';
export const KAT_PRIVAT = '__privat__';

export const SONDER_KATEGORIEN: { id: string; name: string }[] = [
  { id: KAT_ALLGEMEIN, name: 'Allgemein' },
  { id: KAT_PRIVAT, name: 'Privat' },
];

/** Anzeigename einer Sonderkategorie, sonst null. */
export function sonderKatName(id?: string): string | null {
  const k = SONDER_KATEGORIEN.find(s => s.id === id);
  return k !== undefined ? k.name : null;
}
